import React from 'react';

interface CouponBottomLinesProps {
  color: string;
}

const CouponBottomLines: React.FC<CouponBottomLinesProps> = ({ color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="266.744" height="205.355" viewBox="0 0 526.744 275.355">
      <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor={color} stopOpacity="0" />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
      <g transform="translate(-104.046 39.824)">
        <path d="M492.67,0H443.524L373.172,272.835h49.469" transform="translate(-122.662 -39.824)" fill="url(#linear-gradient)" />
        <path d="M216,.97c.007-.323-.005-.647,0-.97H166.534L90.5,271.835h49.47L215.356,3.88A5.7,5.7,0,0,0,216,.97" transform="translate(-46.459 -39.824)" fill="url(#linear-gradient)" />
        <path d="M728.862.026,655.34,275.362h49.47L778.332.026Z" transform="translate(-207.542 -39.831)" fill="url(#linear-gradient)" />
        <path d="M313.862.026,240.34,275.362h49.469L363.331.026Z" transform="translate(-93.237 -39.831)" fill="url(#linear-gradient)" />
        <path d="M590.529.026,517.007,275.362h49.47L640,.026Z" transform="translate(-169.44 -39.831)" fill="url(#linear-gradient)" />
      </g>
    </svg>
  );
};

export default CouponBottomLines; 
